module.exports = __webpack_public_path__ + "static/img/13.8ede5da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/13.png
// module id = 5Wp9
// module chunks = 0